import _ from 'underscore';
import Backbone from 'backbone';
import ProjectUtil from '../utils/project-util.js';

class BaseView extends Backbone.View {
	constructor(options = {}) {
		super(options);
		this.template = null;
		this.pubSub = options.pubSub || ProjectUtil.pubSub; // default to pubSub in options
		this.bindings();
		this.listeners();
		this.postInitialize(options);
		this.renderPage = true;
		this.trigger('initialize');
	}

	getRenderData() {
		if (this.model) {
			return this.model.toJSON();
		} else {
			return {};
		}
	}

	// to be overridden - define the template to be used only when rendering
	async setTemplate() { }

	getTemplate() {
		if (this.template) {
			return this.template;
		}
	}

	getHtml() {
		const template = this.getTemplate();
		if (template) {
			return template(this.getRenderData());
		} else {
			return "";
		}
	}

	// to be overridden - set this.renderPage to false in this function to prevent further rendering actions
	preRender() { }


	async render() {
		this.preRender(...arguments);
		if (this.renderPage) {
			await this.setTemplate();
			// dispatch hide loader event (from PageView only)
			this.hidePageLoader();
			this.$el.html(this.getHtml());
			this.trigger('render');
			this.postRender(...arguments);
		}
		return this;
	}

	append() {
		this.$el.append(this.getHtml());
		this.trigger('render');
		this.postRender(...arguments);
		return this;
	}

	prepend() {
		this.$el.prepend(this.getHtml());
		this.trigger('render');
		this.postRender(...arguments);
		return this;
	}

	// add event in PageView to hide loader
	hidePageLoader() { }

	// to be overridden
	postInitialize() { }

	// to be overridden
	postRender() { }

	// set pubsub listeners: to be overwritten
	listeners() { }

	// Your bindings - to be overridden
	bindings() {
		_.bindAll(this, 'render', 'destroy');
	}

	// Called directly by Router.
	// To be overwritten if you want some sort of 'hide' animation
	hide() {
		this.pubSub.trigger('viewHideComplete', this);
	}

	// remove additional listeners - to be overwritten
	cleanup() { }

	dispose() {
		this.undelegateEvents();
		this.stopListening();
		if (this.model) {
			this.model.off(null, null, this);
		}
		if (this.collection) {
			this.collection.off(null, null, this);
		}
		return this;
	}

	// To be called before view is thrown away. Clean up intervals, events, etc. - to be overridden
	destroy() {
		this.dispose();
		this.cleanup();
		this.$el.removeData().off();
		this.$el.empty();
	}
}

export default BaseView;